import React from 'react';
import Icon from './icon';
import { IconProps } from './types';

const ICON_PATH = 'M14 20L15.0575 18.9425L10.8725 14.75L20 14.75L20 13.25L10.8725 13.25L15.0575 9.0575L14 8L8 14L14 20Z';

export const ArrowBackIcon: React.FC<IconProps> = ({ size, color }) => {
	return <Icon path={ICON_PATH} size={size} color={color} />;
};
